// extracted by mini-css-extract-plugin
module.exports =  {"Footer":"Footer__dZ7qw","pageFooter":"pageFooter__yTfQq proposalContent__o4P6i","breakLine":"breakLine__f7xWM proposalContent__o4P6i"};